import React, {useState, useEffect} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    acceptImage,
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    loaiNoiDungValue,
    messageError,
    messageToast,
    objectLoai,
    objectLoaiNoiDung,
    objectLoaiXuLy,
    objectTrangThaiDeNghi,
    status200,
    styleSelectDefault,
    styleSelectError
} from '../../utils/define';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {BaseGatewayImage, DISEASE_API, EXERCISE_API} from '@app/utils/apiUrl';
import {useMutation, useQuery} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Get, Post} from '@app/utils/httpProvider';
import {WithContext as ReactTags} from 'react-tag-input';
import {isValidUrl, stripHtmlAndDollarSigns} from '../../utils/helper';
import InputFile from '@app/components/input-file/InputFile';
import VideoInput from '@app/components/video-input/VideoInput';

const schema = yup.object().shape({
    name: yup.string().required('Trường dữ liệu không được để trống'),
    diseaseId: yup.object().nullable().required(messageError.emptyMessage),
    imageThumbnail: yup.string().required('Trường dữ liệu không được để trống')
    // loaiNoiDung: yup
    //     .object()
    //     .nullable()
    //     .required('Trường dữ liệu không được để trống'),
});

const ExerciseAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(EXERCISE_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        model.diseaseId =
            values.diseaseId === '' ||
            values.diseaseId === 'null' ||
            values.diseaseId === undefined
                ? ''
                : values.diseaseId.value;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const loadOptions = async (search, loadedOptions, {page}) => {
        const pageSize = 10;
        const res = await Get(DISEASE_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.name}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: {page: page + 1}
        };
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm thông tin bài tập</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        name: '',
                        description: '',
                        // practiceCountMinimum: 0,
                        // practiceCountMaximum: 0,
                        imagePath: '',
                        imageThumbnail: '',
                        diseaseId: null,
                        videoLink: ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Tên"
                                        type="text"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        isInvalid={!!errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.name}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Ảnh đại diện *
                                </Form.Label>
                                <Col sm="10">
                                    <InputFile
                                        enableReinitialize={true}
                                        values={
                                            values.imageThumbnail
                                                ? [
                                                      isValidUrl(
                                                          values.imageThumbnail
                                                      )
                                                          ? values.imageThumbnail
                                                          : BaseGatewayImage +
                                                            values.imageThumbnail
                                                  ]
                                                : []
                                        }
                                        name="imageThumbnail"
                                        accept={acceptImage}
                                        onChange={(files) => {
                                            if (files.length > 0) {
                                                setFieldValue(
                                                    'imagePath',
                                                    files[0].filePath,
                                                    true
                                                );
                                                setFieldValue(
                                                    'imageThumbnail',
                                                    files[0].thumbPath,
                                                    true
                                                );
                                            } else {
                                                setFieldValue(
                                                    'imagePath',
                                                    '',
                                                    true
                                                );
                                                setFieldValue(
                                                    'imageThumbnail',
                                                    '',
                                                    true
                                                );
                                            }
                                        }}
                                    />

                                    <div
                                        style={{
                                            display: 'block',
                                            color: '#dc3545'
                                        }}
                                        className="invalid-feedback"
                                    >
                                        {errors.imageThumbnail}
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Editor
                                        name="description"
                                        value={values.description}
                                        onChange={async (value) => {
                                            setFieldValue('description', value);
                                            if (
                                                values.imagePath === '' ||
                                                values.imageThumbnail === ''
                                            ) {
                                                var divContent =
                                                    document.createElement(
                                                        'div'
                                                    );
                                                divContent.innerHTML = value;
                                                var imgs =
                                                    divContent.querySelectorAll(
                                                        'img'
                                                    );
                                                if (imgs && imgs.length > 0) {
                                                    for (
                                                        let i = 0;
                                                        i < imgs.length;
                                                        i++
                                                    ) {
                                                        if (
                                                            imgs[
                                                                i
                                                            ].getAttribute(
                                                                'src'
                                                            )
                                                        ) {
                                                            console.log(
                                                                'element.getAttribute',
                                                                imgs[
                                                                    i
                                                                ].getAttribute(
                                                                    'src'
                                                                )
                                                            );
                                                            await setFieldValue(
                                                                'imagePath',
                                                                imgs[
                                                                    i
                                                                ].getAttribute(
                                                                    'src'
                                                                ),
                                                                true
                                                            );
                                                            await setFieldValue(
                                                                'imageThumbnail',
                                                                imgs[
                                                                    i
                                                                ].getAttribute(
                                                                    'src'
                                                                ),
                                                                true
                                                            );
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Chọn bệnh lý *
                                </Form.Label>
                                <Col sm="10">
                                    <AsyncPaginate
                                        name="diseaseId"
                                        id="diseaseId"
                                        placeholder="Chọn bệnh lý"
                                        value={values.diseaseId}
                                        loadOptions={loadOptions}
                                        styles={styleSelectDefault}
                                        isClearable
                                        onChange={(selectedOption) => {
                                            // const event = {
                                            //     target: {
                                            //         name: 'accountPatients',
                                            //         value: selectedOption
                                            //     }
                                            // };
                                            // setAccountHisId(event);
                                            setFieldValue(
                                                'diseaseId',
                                                selectedOption,
                                                true
                                            );
                                        }}
                                        additional={{
                                            page: 1
                                        }}
                                    />
                                    <div
                                        style={{
                                            display: 'block',
                                            color: '#dc3545'
                                        }}
                                        className="invalid-feedback"
                                    >
                                        {errors.diseaseId}
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Đường dẫn video
                                </Form.Label>
                                <Col sm="10">
                                    <VideoInput
                                        isInvalid={!!errors.videoLink}
                                        errorsValue={errors.videoLink}
                                        value={values.videoLink}
                                        onChangeProp={(value) => {
                                            setFieldValue('videoLink', value);
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                            {/* <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Số lần tối thiểu tập mỗi buổi
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Số lần tối thiểu tập mỗi buổi"
                                        type="number"
                                        name="practiceCountMinimum"
                                        value={values.practiceCountMinimum}
                                        onChange={handleChange}
                                        // isInvalid={!!errors.practiceCountMinimum}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Số lần tối đa tập mỗi buổi
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Số lần tối đa tập mỗi buổi"
                                        type="number"
                                        name="practiceCountMaximum"
                                        value={values.practiceCountMaximum}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group> */}
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{span: 10, offset: 2}}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default ExerciseAdd;
